import React, { useState } from "react";
import { useAppDispatch } from "../..";
import { setSingleMarkerResult } from "../../store/reducers/map";
import Partner from "../../types/Partner";
import MarkerComponent from "./MarkerComponent";

interface MarkerComponentContainerProps {
  partners: Partner[];
}

const MarkerComponentContainer = (props: MarkerComponentContainerProps) => {
  const { partners } = props;

  const dispatch = useAppDispatch();

  const [openInfoWindow, setOpenInfoWindow] = useState<any>({});

  const handleMarkerClick = (partner: Partner) => {
    dispatch(setSingleMarkerResult({ singleMarkerResult: partner }));
    const openInfoWindowObj = createCurrentOpenInfoWindowObj(
      partner.id.toString()
    );
    setOpenInfoWindow(openInfoWindowObj);
  };

  const createCurrentOpenInfoWindowObj = (partnerId: string) => {
    let openInfoWidowObj: any = {};
    openInfoWidowObj[partnerId] = true;
    return openInfoWidowObj;
  };

  return (
    <MarkerComponent
      handleMarkerClick={handleMarkerClick}
      openInfoWindow={openInfoWindow}
      partners={partners}
    />
  );
};

export default MarkerComponentContainer;
